import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const me = require('../images/me3.jpg');

class About extends Component {
	constructor(props) {
		super(props);
		this.about = React.createRef();
	}
	componentDidMount() {
		this.props.divStart(
			this.about.current.id,
			this.about.current.offsetTop
		);
		window.addEventListener('resize', this.onResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	onResize = () => {
		this.props.divStart(
			this.about.current.id,
			this.about.current.offsetTop
		);
	};

	render() {
		return (
			<section className="about" id="about" ref={this.about}>
				<h1 className="heading-primary section-heading-primary section-heading-primary--white">
					About
				</h1>
				<div className="about__content">
					<div className="about__info">
						<figure className="about__shape">
							<img src={me} alt="Me" className="about__img" />
						</figure>
						<h2 className="heading-secondary">
							I am a very passionate software engineer
							specializing in web and mobile applications
						</h2>
						<p className="paragraph">
							I discovered the world of software engineering back
							in 2009 and I became obsessed. Since then, I have
							devoted most of my free time to keeping up with the
							industry, testing out a new library, or building a
							new app. When I am not at my computer, I enjoy
							weight training, learning Japanese, aerial yoga,
							gaming, and hiking.
						</p>
					</div>
					<div className="icon">
						<h2 className="icon__heading heading-secondary">
							Skills
						</h2>
						<ul className="icon__list">
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'html5']}
									size="6x"
									className="html5"
								/>
								<span className="icon__label">HTML 5</span>
							</li>
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'css3-alt']}
									size="6x"
									className="css3"
								/>
								<span className="icon__label">CSS 3</span>
							</li>
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'js']}
									size="6x"
									className="js"
								/>

								<span className="icon__label">JavaScript</span>
							</li>
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'node']}
									size="6x"
									className="node"
								/>

								<span className="icon__label">NodeJS</span>
							</li>
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'git-alt']}
									size="6x"
									className="git"
								/>
								<span className="icon__label">Git</span>
							</li>
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'react']}
									size="6x"
									className="react"
								/>
								<span className="icon__label">React</span>
							</li>
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'sass']}
									size="6x"
									className="sass"
								/>
								<span className="icon__label">Sass</span>
							</li>
							<li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'wordpress']}
									size="6x"
									className="wordpress"
								/>
								<span className="icon__label">Wordpress</span>
							</li>
							{/* <li className="icon__item">
								<FontAwesomeIcon
									icon={['fab', 'python']}
									size="6x"
									className="python"
								/>
								<span className="icon__label">Python</span>
							</li> */}
						</ul>
					</div>
				</div>
			</section>
		);
	}
}

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js